import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ProjectHero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return <section data-section-id="25197" id="hero-kerjasama-mitra-strategis" className="relative h-[80vh] md:h-screen min-h-[500px] md:min-h-[600px] w-full overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/scala_hotel_exterior_hero.png)] bg-cover bg-center bg-no-repeat" />

      {}
      <div className="absolute inset-0 bg-secondary/50 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-6 md:px-12 text-center">
        {}
        <h1 className={`font-serif text-4xl sm:text-5xl font-bold text-primary-foreground md:text-6xl lg:text-7xl leading-tight transition-all duration-1000 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        letterSpacing: "-0.01em"
      }}>
          Kemitraan Strategis
        </h1>

        {}
        <p className={`mt-6 max-w-md sm:max-w-2xl lg:max-w-3xl font-sans text-base sm:text-lg text-primary-foreground/90 md:text-xl lg:text-2xl transition-all duration-1000 delay-300 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          Membangun sinergi berkelanjutan untuk kemajuan bersama melalui kolaborasi yang kokoh, transparan, dan berdampak luas bagi masyarakat.
        </p>

        {}
        <div className={`mt-12 md:mt-10 transition-all duration-1000 delay-500 ease-out ${loaded ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild className="h-auto rounded-lg bg-primary px-8 py-3 text-base font-semibold text-primary-foreground shadow-xl hover:bg-primary/90 transition-all hover:scale-105 md:px-10 md:py-4 md:text-lg">
            <Link to="#">
              Jelajahi Kerjasama
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}